export default __webpack_public_path__ + "img/7247157f9997cf867725a9474d3a1c04.svg";